const portfolioContent = {
    bg: `contentBg`,
    borderRadius: `full`,
    display: `flex`,
    flexDirection: `column`,
    px: 4,
    py: 4
  }
  
  export default portfolioContent